<template>
  <div id="ExecutionFeedback">
    <el-card shadow="never" v-loading="cardLoading">
      <el-form
        :rules="formData1Rules"
        label-suffix="："
        :model="formData1"
        ref="formData1"
        label-width="200px"
        label-position="left"
      >
        <el-row :gutter="16">
          <el-col :lg="8" :md="8" :sm="24" :xs="24">
            <el-form-item :label="$t('approvalCenter.ActualStartDate')" prop="realStartDate">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                :readonly="disable"
                type="datetime"
                v-model="formData1.realStartDate"
                :placeholder="$t('approvalCenter.sdat')"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="8" :sm="24" :xs="24">
            <el-form-item :label="$t('approvalCenter.ActualEndDate')" prop="realEndDate">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                :readonly="disable"
                type="datetime"
                v-model="formData1.realEndDate"
                :placeholder="$t('approvalCenter.sdat')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16" v-if="oldVersion === '1'">
          <el-col :lg="24" :md="24" :sm="24" :xs="24">
            <el-form-item :label="$t('approvalCenter.ass')" prop="fbEarlyRule">
              <div style="display: flex">
                <span>{{ $t('approvalCenter.ess') }}：</span>
                <el-checkbox-group v-model="formData1.fbEarly" :disabled="disable">
                  <el-checkbox
                    v-for="item in multiSelectList.fbEarly"
                    :key="item.fieldKey"
                    :label="item.fieldKey"
                  >
                    {{ item.fieldValue }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <div style="display: flex">
                <span>{{ $t('approvalCenter.oss') }}：</span>
                <el-checkbox-group v-model="formData1.fbLater" :disabled="disable">
                  <el-checkbox
                    v-for="item in multiSelectList.fbLater"
                    :key="item.fieldKey"
                    :label="item.fieldKey"
                  >
                    {{ item.fieldValue }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16" v-if="oldVersion ==='0' && !useSimplifiedForm">
          <el-col :lg="24" :md="24" :sm="24" :xs="24">
            <el-form-item :label="$t('approvalCenter.ppss')" prop="fbSupportSituation">
              <el-radio-group v-model="formData1.fbSupportSituation">
                <el-radio
                  :disabled="disable"
                  v-for="item in multiSelectList.fbSupportSituation"
                  :key="item.fieldKey"
                  :label="item.fieldKey"
                >
                  {{ item.fieldValue }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <!-- <el-col :lg="8" :md="8" :sm="24" :xs="24" v-if="!useSimplifiedForm">
            <el-form-item :label="$t('approvalCenter.toc')">
              <el-checkbox-group v-model="formData1.fbCustomerType" :disabled="disable">
                <el-checkbox
                  v-for="item in multiSelectList.fbCustomerType"
                  :key="item.fieldKey"
                  :label="item.fieldKey"
                >
                  {{ item.fieldValue }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col> -->
          <el-col :lg="8" :md="8" :sm="24" :xs="24">
            <el-form-item :label="$t('approvalCenter.anop')" prop="customerAmount" class="customer">
              <el-input
                oninput="if(value<0)value=0"
                @input="customerAmountFilter"
                disabled
                :readonly="disable"
                v-model.trim="formData1.customerAmount"
                :min="0"
                maxlength="6"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="8" :sm="24" :xs="24">
            <el-form-item
              :label="$t('approvalCenter.anop1')"
              prop="customerAmountDm"
              class="customer"
            >
              <el-input :readonly="disable" v-model.trim="formData1.customerAmountDm" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16" v-if="!useSimplifiedForm">
          <!-- <el-col :lg="8" :md="8" :sm="24" :xs="24">
            <el-form-item :label="$t('approvalCenter.jaon')" prop="isUnionMarket">
              <el-radio-group
                v-model="formData1.isUnionMarket"
                @change="changeUnionMarket"
                :disabled="disable"
              >
                <el-radio label="1">{{ $t('general.yes') }}</el-radio>
                <el-radio label="0">{{ $t('general.no') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col> -->
          <el-col :lg="8" :md="8" :sm="24" :xs="24">
            <el-form-item
              :label="$t('newApp.activityInfo.ic')"
              v-if="formData1.isUnionMarket === '1'"
              prop="isInternationalQd"
            >
              <el-radio-group
                v-model="formData1.isInternationalQd"
                @change="isInternationalQdChange"
                :disabled="disable"
              >
                <el-radio :label="1">{{ $t('general.yes') }}</el-radio>
                <el-radio :label="0">{{ $t('general.no') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="8" :sm="24" :xs="24">
            <el-form-item
              :label="$t('newApp.activityInfo.cst')"
              v-if="formData1.isUnionMarket === '1'"
              prop="unionCustomerType"
            >
              <el-select
                v-model="formData1.unionCustomerType"
                :disabled="disable"
                :placeholder="$t('general.ps')"
                @change="unionCustomerTypeChange"
              >
                <el-option
                  v-for="(item,index) in unionCustomerTypeList"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="8" :sm="24" :xs="24">
            <el-form-item
              :label="$t('approvalCenter.jspc')"
              v-if="formData1.isUnionMarket === '1'"
              prop="unionCustomer"
            >
              <el-select
                :disabled="disable"
                v-model="formData1.unionCustomer"
                filterable
                remote
                reserve-keyword
                :placeholder="$t('general.CEtsbn')"
                :remote-method="qdMethods"
                :loading="selectLoading"
              >
                <el-option
                  v-for="(item,index) in qdNameList"
                  :key="index"
                  :label="item.CompanyName"
                  :value="item.CompanyName"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16" v-if="!useSimplifiedForm">
          <!-- <el-col :lg="8" :md="8" :sm="24" :xs="24">
            <el-form-item :label="$t('approvalCenter.hydaq')" prop="isFillQuestionnaire">
              <el-radio-group v-model="formData1.isFillQuestionnaire" :disabled="disable">
                <el-radio label="1">{{ $t('general.yes') }}</el-radio>
                <el-radio label="0">{{ $t('general.no') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col> -->
          <el-col :lg="8" :md="8" :sm="24" :xs="24" v-if="formData1.isFillQuestionnaire === '0'">
            <el-form-item :label="$t('approvalCenter.rfncq')" prop="unCollectionReason">
              <el-input
                :readonly="disable"
                v-model="formData1.unCollectionReason"
                :placeholder="$t('general.CE_awysN')"
                maxlength="100"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16" v-if="formData1.isFillQuestionnaire === '1' && !useSimplifiedForm">
          <el-col :lg="8" :md="8" :sm="24" :xs="24">
            <el-form-item :label="$t('approvalCenter.noqc')" prop="questionnaireAmount">
              <el-input
                @input="questionnaireAmountFilter"
                :placeholder="$t('general.ClickEnter')"
                :readonly="disable"
                :disabled="dmDisable"
                v-model.trim="formData1.questionnaireAmount"
                oninput="if(value<0)value=0"
                :min="0"
                maxlength="6"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="8" :sm="24" :xs="24">
            <el-form-item :label="$t('approvalCenter.nosl')" prop="salesLeadAmount">
              <el-input
                oninput="if(value<0)value=0"
                @input="salesLeadAmountFilter"
                :placeholder="$t('general.ClickEnter')"
                :readonly="disable"
                :disabled="dmDisable"
                v-model.trim="formData1.salesLeadAmount"
                :min="0"
                maxlength="6"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16" v-if="oldVersion ==='0' && !useSimplifiedForm">
          <el-col :lg="8" :md="8" :sm="24" :xs="24">
            <el-form-item :label="$t('approvalCenter.iaon')" prop="isImportantActivity">
              <el-radio-group v-model="formData1.isImportantActivity" :disabled="disable">
                <el-radio label="1">{{ $t('general.yes') }}</el-radio>
                <el-radio label="0">{{ $t('general.no') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :lg="16" :md="16" :sm="24" :xs="24" class="remark-box">
            <el-form-item :label="$t('general.Remarks')" prop="fbRemarks" label-width="100px">
              <el-checkbox-group
                v-model="formData1.fbRemarks"
                @change="remarkChange"
                :disabled="disable"
              >
                <el-checkbox
                  v-for="item in multiSelectList.fbRemarks"
                  :label="item.fieldKey"
                  :key="item.fieldKey"
                >
                  {{ item.fieldValue }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-input
              v-if="isOther"
              :readonly="disable"
              v-model="formData1.other"
              :placeholder="$t('general.pec')"
            />
          </el-col>
        </el-row>
        <el-row :gutter="16" v-if="isRepetition && oldVersion ==='0' && !useSimplifiedForm">
          <el-col :lg="8" :md="8" :sm="24" :xs="24">
            <el-form-item :label="$t('approvalCenter.oan')" prop="relationCode">
              <el-input
                :readonly="disable"
                v-model="formData1.relationCode"
                :placeholder="$t('eventList.Petoetn')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16" v-if="feedBackData.showKolAndDemo">
          <el-col :lg="8" :md="8" :sm="24" :xs="24">
            <el-form-item :label="$t('approvalCenter.KOL')" prop="kolShare">
              <el-radio-group v-model="formData1.kolShare" :disabled="disable">
                <el-radio label="1">{{ $t('general.yes') }}</el-radio>
                <el-radio label="0">{{ $t('general.no') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="8" :sm="24" :xs="24">
            <el-form-item :label="$t('approvalCenter.Demo')" prop="machineDemo">
              <el-radio-group v-model="formData1.machineDemo" :disabled="disable">
                <el-radio label="1">{{ $t('general.yes') }}</el-radio>
                <el-radio label="0">{{ $t('general.no') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :lg="8" :md="8" :sm="24" :xs="24" v-if="!useSimplifiedForm">
            <!-- 活动客户VOC记录链接 -->
            <el-form-item :label="$t('approvalCenter.ActivityCustomerVOCLink')" prop="videoUrl">
              <el-input
                :readonly="disable"
                v-model="formData1.videoUrl"
                :placeholder="$t('general.ClickEnter')"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-form
      :rules="formData2Rules"
      label-suffix="："
      :model="formData2"
      ref="formData2"
      label-width="140px"
      label-position="left"
      v-show="false"
    />
    <!--    <el-card shadow="never" v-loading="cardLoading" style="margin-top: 16px" v-if="roleObj.role === 'imc'">-->
    <!--      <el-form :rules="formData2Rules" label-suffix="：" :model="formData2" ref="formData2" label-width="140px" label-position="left">-->
    <!--        <el-row :gutter="16">-->
    <!--          <el-col :lg="24" :md="24" :sm="24" :xs="24">-->
    <!--            <el-form-item label="活动职责">-->
    <!--              <el-checkbox-group v-show="!disable" v-model="formData2.fbActivityDuty">-->
    <!--                <el-checkbox v-for="item in multiSelectList.fbActivityDuty" :key="item.fieldKey" :label="item.fieldKey">{{ item.fieldValue }}</el-checkbox>-->
    <!--              </el-checkbox-group>-->
    <!--              <span v-show="disable">{{ formData2.fbActivityDutyStr }}</span>-->
    <!--            </el-form-item>-->
    <!--          </el-col>-->
    <!--        </el-row>-->
    <!--        <el-row :gutter="16">-->
    <!--          <el-col :lg="24" :md="24" :sm="24" :xs="24">-->
    <!--            <el-form-item label="活动板块">-->
    <!--              <div v-if="formData2.activitiesSection.length >1">-->
    <!--                <div v-for="(item,index) in activitiesSectionList" :key="item.title" style="display: flex">-->
    <!--                  <span :style="{'width': item.width,'display': 'inline-table'}">{{ item.title }}：</span>-->
    <!--                  <el-checkbox-group v-show="!disable" v-model="formData2.activitiesSection[index].value">-->
    <!--                    <el-checkbox v-for="itemList in item.list" :key="itemList.fieldKey" :label="itemList.fieldKey">{{ itemList.fieldValue }}</el-checkbox>-->
    <!--                  </el-checkbox-group>-->
    <!--                  &lt;!&ndash;<span v-show="disable" v-for="itemList in item.list">{{ itemList.fieldValue+'、' }}</span>&ndash;&gt;-->
    <!--                  <span v-show="disable">{{ formData2.activitiesSectionStrList[index] }}</span>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </el-form-item>-->
    <!--          </el-col>-->
    <!--        </el-row>-->
    <!--        <el-row :gutter="16">-->
    <!--          <el-col :lg="24" :md="24" :sm="24" :xs="24">-->
    <!--            <el-form-item label="报告内容优化">-->
    <!--              <el-checkbox-group v-show="!disable" v-model="formData2.fbReportOptimization">-->
    <!--                <el-checkbox v-for="item in multiSelectList.fbReportOptimization" :key="item.fieldKey" :label="item.fieldKey">{{ item.fieldValue }}</el-checkbox>-->
    <!--              </el-checkbox-group>-->
    <!--              <el-input v-show="!disable && formData2.fbReportOptimization.indexOf('OPT_07') > -1" v-model="formData2.other" placeholder="点击输入（选择其它时出现）" maxlength="50" />-->
    <!--              <span v-show="disable">{{ formData2.fbReportOptimizationStr }}</span>-->
    <!--            </el-form-item>-->
    <!--          </el-col>-->
    <!--        </el-row>-->
    <!--        &lt;!&ndash;<el-row :gutter="16" >-->
    <!--          <el-col :lg="12" :md="12" :sm="24" :xs="24">-->
    <!--            <el-input placeholder="点击输入（选择其他时出现）" />-->
    <!--          </el-col>-->
    <!--        </el-row>&ndash;&gt;-->
    <!--        <el-row :gutter="16">-->
    <!--          <el-col :lg="24" :md="24" :sm="24" :xs="24">-->
    <!--            <el-form-item label="支持人员">-->
    <!--              <el-select v-show="!disable" value-key="userId" clearable multiple v-model.trim="formData2.supporter" filterable remote reserve-keyword placeholder="点击输入，可添加多人（姓名搜索）" :remote-method="supporterMethods" :loading="selectLoading" ref="select">-->
    <!--                <el-option v-for="item in supporterList" :key="item.userId" :label="item.userName" :value="item" />-->
    <!--              </el-select>-->
    <!--              <span v-show="disable">{{ this.formData2.supporterStr }}</span>-->
    <!--            </el-form-item>-->
    <!--          </el-col>-->
    <!--          &lt;!&ndash;<el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">-->
    <!--            <el-form-item label="支持人员" prop="saler">-->
    <!--              <el-select-->
    <!--                v-model.trim="formData2.supporter"-->
    <!--                filterable-->
    <!--                remote-->
    <!--                reserve-keyword-->
    <!--                placeholder="点击输入，可添加多人（姓名搜索）"-->
    <!--                :remote-method="supporterMethods"-->
    <!--                :loading="selectLoading"-->
    <!--              >-->
    <!--                <el-option v-for="item in supporterList" :key="item.userId" :label="item.userName" :value="item" />-->
    <!--              </el-select>-->
    <!--            </el-form-item>-->
    <!--          </el-col>&ndash;&gt;-->
    <!--        </el-row>-->
    <!--      </el-form>-->
    <!--    </el-card>-->
    <el-button style="margin: 8px 0" type="primary" @click="handleSubmit">{{ btn_content }}</el-button>
    <!--活动附件-->
    <activityFile
      ref="activityFile"
      :echo-data="echoData"
    />
    <el-card
      v-if="roleObj.role === 'imc' && tableData.length > 0"
      shadow="never"
      v-loading="cardLoading"
      style="margin-top: 16px"
    >
      <el-table :data="tableData" v-loading="tableLoading" max-height="600" border stripe>
        <el-table-column
          prop="createUserName"
          min-width="120"
          show-overflow-tooltip
          :label="$t('approvalCenter.fp')"
          align="center"
        />
        <el-table-column
          prop="createTime"
          min-width="120"
          show-overflow-tooltip
          :label="$t('approvalCenter.tof')"
          align="center"
        />
        <el-table-column
          prop="modifyTime"
          min-width="120"
          show-overflow-tooltip
          :label="$t('approvalCenter.lmt')"
          align="center"
        />
        <el-table-column
          width="120"
          show-overflow-tooltip
          :label="$t('general.Operation')"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="handleDetails(scope.row)">{{ $t('btn.View') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <ExecutionFeedbackModel ref="ExecutionFeedbackModel" />
  </div>
</template>

<script>
import ExecutionFeedbackModel from '@/views/activitieList/component/activityDetails/components/ExecutionFeedbackModel';
import { ExecutionFeedbackServer } from '@/API/executionFeedback';
import { confirmPrecheck, notifyDetectFailed } from '@/utils/exportComplianceDialog';
import { getYYYYMMDD, isNotEmpty, throttle } from '@/utils/utils';
import { newApplicationFormApi } from '../../../newApplicationForm/service';
import { travellingTrader } from '../../service';
import activityFile from './activityFile';

let timer;
export default {
  components: { ExecutionFeedbackModel, activityFile },
  name: 'ExecutionFeedback',
  data () {
    const validateFbEarlyRule = (rule, value, callback) => {
      if (this.formData1.fbEarly.length < 1) {
        callback(new Error(this.$t('approvalCenter.PromptMsg2')));
      }
      if (this.formData1.fbLater.length < 1) {
        callback(new Error(this.$t('approvalCenter.PromptMsg3')));
      }
      callback();
    };
    const customerAmountValidate = (rule, value, callback) => {
      if (value < 1) {
        callback(new Error(this.$t('approvalCenter.PromptMsg4')));
      }
      callback();
    };
    return {
      // 第一个模块
      formData1: {
        realStartDate: '',
        realEndDate: '',
        fbEarly: [],
        fbLater: [],
        fbCustomerType: [],
        customerAmount: '',
        customerAmountDm: '',
        unionCustomerType: '',
        unionCustomer: '',
        fbEarlyStr: '',
        fbLaterStr: '',
        fbCustomerTypeStr: '',
        isInternationalQd: 1,
        isImportantActivity: '',
        isImportantActivityStr: '',
        fbRemarks: [],
        fbRemarksStr: '',
        fbSupportSituation: null,
        fbSupportSituationStr: '',
        relationCode: '',
        videoUrl: '',
        other: '',
        kolShare: '',
        machineDemo: ''
      },
      feedBackData: {},
      isRepetition: false,
      isOther: false,
      oldVersion: '',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      formData1Rules: {
        realStartDate: [
          {
            required: true,
            message: this.$t('general.psad'),
            trigger: 'change'
          }
        ],
        realEndDate: [
          {
            required: true,
            message: this.$t('general.psad'),
            trigger: 'change'
          }
        ],
        fbEarlyRule: [
          {
            type: 'array',
            required: true,
            validator: validateFbEarlyRule,
            trigger: 'change'
          }
        ],
        customerAmount: [
          { required: true, message: this.$t('general.cbe'), trigger: 'blur' },
          { validator: customerAmountValidate, trigger: 'blur' }
        ],
        isUnionMarket: [
          {
            required: true,
            message: this.$t('approvalCenter.pswtja'),
            trigger: 'change'
          }
        ],
        isInternationalQd: [
          {
            required: true,
            message: this.$t('approvalCenter.psic'),
            trigger: 'change'
          }
        ],
        unionCustomerType: [
          { required: true, message: this.$t('general.cbe'), trigger: 'blur' }
        ],
        unionCustomer: [
          { required: true, message: this.$t('general.cbe'), trigger: 'blur' }
        ],
        isFillQuestionnaire: [
          {
            required: true,
            message: this.$t('approvalCenter.pswtdtqon'),
            trigger: 'change'
          }
        ],
        unCollectionReason: [
          { required: true, message: this.$t('general.cbe'), trigger: 'blur' }
        ],
        kolShare: [
          { required: true, message: this.$t('approvalCenter.pskol'), trigger: 'change' }
        ],
        machineDemo: [
          { required: true, message: this.$t('approvalCenter.psmd'), trigger: 'change' }
        ],
        questionnaireAmount: [
          { required: true, message: this.$t('general.cbe'), trigger: 'blur' }
        ],
        salesLeadAmount: [
          { required: true, message: this.$t('general.cbe'), trigger: 'blur' }
        ],
        isImportantActivity: [
          {
            required: false,
            message: this.$t('approvalCenter.psaia'),
            trigger: 'change'
          }
        ],
        fbRemarks: [
          {
            type: 'array',
            required: false,
            message: this.$t('general.ps'),
            trigger: 'change'
          }
        ],
        fbSupportSituation: [
          {
            required: false,
            message: this.$t('approvalCenter.pstpps'),
            trigger: 'change'
          }
        ],
        relationCode: [
          { required: true, message: this.$t('general.cbe'), trigger: 'blur' }
        ],
        other: [
          { required: false, message: this.$t('general.pec'), trigger: 'blur' }
        ]
      },
      formData2: {
        fbActivityDuty: [],
        activitiesSection: [], // 活动模块-数据
        fbReportOptimization: [],
        supporter: [],
        isFillQuestionnaire: '',
        unCollectionReason: '',
        questionnaireAmount: '',
        salesLeadAmount: '',
        other: '',
        fbActivityDutyStr: '',
        activitiesSectionStrList: [], // 活动模块
        fbReportOptimizationStr: '',
        supporterStr: '',
        isFillQuestionnaireStr: ''
      },
      unionCustomerTypeList: [], // 渠道类型可选项list
      // 活动模块-选项
      activitiesSectionList: [
        {
          title: '会议',
          width: '50px',
          key: 'fbMeeting',
          list: []
        },
        {
          title: '产品体验',
          width: '80px',
          key: 'fbProductExperience',
          list: []
        },
        {
          title: '样板参观',
          width: '80px',
          key: 'fbTemplate',
          list: []
        },
        {
          title: '线上直播',
          width: '80px',
          key: 'fbLiveBroadcast',
          list: []
        },
        {
          title: '展会',
          width: '50px',
          key: 'fbExhibition',
          list: []
        },
        {
          title: '策划案',
          width: '60px',
          key: 'fbCase',
          list: []
        },
        {
          title: '特殊支持',
          width: '80px',
          key: 'fbSupport',
          list: []
        },
        {
          title: '客户站台',
          width: '80px',
          key: 'fbCustomerPlatform',
          list: []
        },
        {
          title: '体验中心参观',
          width: '100px',
          key: 'fbExperience',
          list: []
        }
      ],
      formData2Rules: {
        // isFillQuestionnaire: [{ required: true, message: '请选择是否做了问卷', trigger: 'change' }],
        // unCollectionReason: [{ required: true, message: '不能为空', trigger: 'blur' }],
        // questionnaireAmount: [{ required: true, message: '不能为空', trigger: 'blur' }],
        // salesLeadAmount: [{ required: true, message: '不能为空', trigger: 'blur' }]
      },
      tableData: [],
      tableLoading: false,
      cardLoading: false,
      selectLoading: false,
      multiSelectList: [], // 多选数组
      roleObj: {
        role: 'saler'
      },
      supporterList: [],
      qdNameList: [],
      btn_content: this.$t('btn.Submit'), // 提交按钮的文本
      disable: false,
      dmDisable: false, // true-有DM数据，需要禁用； false-没有DM数据，不禁用
      loadingMask: null
    };
  },
  props: {
    echoData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    activityCode () {
      return this.$route.query.activityCode;
    },
    useSimplifiedForm () {
      return this.$store.state.useSimplifiedForm;
    }
  },
  mounted () {
    // 获取参会客户单位总数（实际参会人数）
    this.getCustomerList();
    this.feedbackUseAxios();
    this.feedbackOptionsAxios();
    this.getChannelTypeList(1);
  },
  methods: {
    async getCustomerList () {
      let res = await travellingTrader.getTravellingTraderData({
        activityCode: this.$route.query.activityCode,
        pageSize: 10,
        pageNum: 1
      });
      if (res.status === '200') {
        let amount = res.data.pageInfo && res.data.pageInfo.total ? res.data.pageInfo.total : 0;
        this.$set(this.formData1, 'customerAmount', amount);
        if (!amount) {
          this.$confirm(
            this.$t('approvalCenter.PromptMsg1'),
            this.$t('general.Hint'),
            {
              confirmButtonText: this.$t('btn.OK'),
              cancelButtonText: this.$t('btn.Cancel'),
              type: 'warning'
            }
          )
            .then(() => {
              this.$emit('jumpTabsHandle', { name: 'travellingTrader' });
            })
            .catch(() => {});
        }
      }
    },
    // 备注修改事件
    remarkChange (e) {
      this.isRepetition = e.findIndex(item => item === 'REMARKS_01') !== -1;
      this.isOther = e.findIndex(item => item === 'REMARKS_04') !== -1;
    },
    isInternationalQdChange (val) {
      this.getChannelTypeList(val);
      this.$set(this.formData1, 'unionCustomerType', '');
      this.$set(this.formData1, 'unionCustomer', '');
    },
    isFillQuestionnaireChanged (val) {
      if (val === '0') {
        this.formData1.questionnaireAmount = '';
        this.formData1.salesLeadAmount = '';
      } else if (val === '1') {
        this.formData1.unCollectionReason = '';
      }
    },
    getChannelTypeList (internationalFlag) {
      let params = internationalFlag ? 1 : 0;
      newApplicationFormApi.getChannelTypeList(params).then(res => {
        if (res.status === '200') {
          this.unionCustomerTypeList = res.data;
        }
      });
    },
    unionCustomerTypeChange () {
      // this.unionChannelNameList = [];
      // this.$set(this.formData, 'unionChannelName', '');
      this.formData1.unionCustomer = '';
      this.qdNameList = [];
    },
    changeUnionMarket (val) {
      this.formData1.unionCustomerType = '';
      this.formData1.unionCustomer = '';
      /* if (val === '1') {
          this.formData1Rules.unionCustomerType[0].required = true;
          this.formData1Rules.unionCustomer[0].required = true;
        } else {
          this.formData1Rules.unionCustomerType[0].required = false;
          this.formData1Rules.unionCustomer[0].required = false;
        } */
    },
    // 支持人员下拉
    supporterMethods (query) {
      this.selectLoading = true;
      if (query !== '') {
        if (timer) {
          window.clearTimeout(timer);
        }
        timer = setTimeout(() => {
          this.getSalesmanListAxios(query);
        }, 200);
      }
    },
    remoteMethod (query) {
      if (query !== '') {
        this.selectLoading = true;
        newApplicationFormApi.getSalesmanList(query).then(res => {
          if (res.status === '200') {
            if (res.data && res.data.length > 0) {
              this.saleList = res.data.map(item => {
                return {
                  ...item,
                  combination: `${item.userName}/${item.deptName}`
                };
              });
            } else {
              this.saleList = [];
            }
          }
          this.saleLoading = false;
        });
      } else {
        this.saleList = [];
      }
    },
    async getSalesmanListAxios (name) {
      try {
        const result = await ExecutionFeedbackServer.getSalesmanList(name);
        if (result.status === '200') {
          this.supporterList = result.data;
        }
      } catch {
        this.$notify.error(this.$t('general.ServerError'));
      }
      this.selectLoading = false;
    },
    handleSubmit () {
      if (this.btn_content === this.$t('btn.Edit')) {
        // 按钮文字变为“提交”
        this.btn_content = this.$t('btn.Submit');
        // 页面文本框设为disable
        this.disable = false;
        this.feedbackOneAxios(null);
        return;
      }
      this.handleSubmitCommand();
    },
    handleSubmitCommand: throttle(function () {
      this.$refs.formData1.validate((valid) => {
        if (valid) {
          if (this.roleObj.role === 'saler') {
            this.assemblyMethods();
            return;
          }
          this.$refs.formData2.validate((valid) => {
            if (valid) {
              this.loadingMask = this.$loading({
                lock: true,
                text: this.$t('general.Loading'),
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              this.assemblyMethods();
            }
          });
          // // 重新从数据库加载数据
          // this.feedbackUseAxios();
        }
      });
    }, 1000),
    assemblyMethods () {
      const from1 = JSON.parse(JSON.stringify(this.formData1));
      const from2 = JSON.parse(JSON.stringify(this.formData2));
      const data = {};
      // 简化表单模式下清空被隐藏的字段值，避免旧数据残留
      if (this.useSimplifiedForm) {
        from1.fbSupportSituation = null;
        from1.fbCustomerType = [];
        from1.isUnionMarket = null;
        from1.isInternationalQd = null;
        from1.unionCustomerType = '';
        from1.unionCustomer = '';
        from1.isFillQuestionnaire = null;
        from1.unCollectionReason = '';
        from1.questionnaireAmount = '';
        from1.salesLeadAmount = '';
        from1.isImportantActivity = '';
        from1.fbRemarks = [];
        from1.relationCode = '';
        from1.other = '';
      }
      // if (this.$refs.activityFile.fileList.length > 0) {
      //   data.attachFileList = this.$refs.activityFile.fileList.map(item => {
      //     return {
      //       fileId: item.response ? item.response.data[0].FID : item.fileId,
      //       fileName: item.name,
      //       activityCode: this.activityCode,
      //       sourceType: 'FeedBack'
      //     };
      //   });
      // }
      data.mactFeedback = {}; // 单选项、单个的文本框在此对象内存储
      data.mactFeedback.activityCode = this.activityCode;
      data.mactFeedback.realStartDate = from1.realStartDate;
      data.mactFeedback.realEndDate = from1.realEndDate;
      // data.mactFeedback.realStartDate = getYYYYMMDD(
      //   from1.realStartDate
      // ).nDateTime;
      // data.mactFeedback.realEndDate = getYYYYMMDD(from1.realEndDate).nDateTime;
      // data.customerType = ''; // 客户类型
      data.mactFeedback.customerAmount = from1.customerAmount;
      data.mactFeedback.isUnionMarket = from1.isUnionMarket;
      data.mactFeedback.isInternationalQd = from1.isInternationalQd;
      data.mactFeedback.unionCustomerType = from1.unionCustomerType;
      data.mactFeedback.unionCustomer = from1.unionCustomer; // 联合的渠道或服务商
      data.mactFeedback.relationCode = from1.relationCode;
      data.mactFeedback.other = from1.other;
      data.mactFeedback.isImportantActivity = from1.isImportantActivity * 1;
      // data.mactFeedback.unionCustomerName = ''; // 联合的渠道或服务商编码

      data.mactFeedback.supporter = ''; // 支持人员
      data.mactFeedback.videoUrl = from1.videoUrl; // 活动视频链接
      data.mactFeedback.kolShare = from1.kolShare; // KOL站台/样板客户分享
      data.mactFeedback.machineDemo = from1.machineDemo; // 样机演示/体验
      // from2.supporter.forEach(item => {
      //   data.mactFeedback.supporter += `${item.userId}|${item.userName};`;
      // });
      data.mactFeedback.isFillQuestionnaire = from1.isFillQuestionnaire;
      if (from1.isFillQuestionnaire === '0') {
        data.mactFeedback.questionnaireAmount = '';
        data.mactFeedback.salesLeadAmount = '';
        data.mactFeedback.unCollectionReason = from1.unCollectionReason;
      } else if (from1.isFillQuestionnaire === '1') {
        data.mactFeedback.questionnaireAmount = from1.questionnaireAmount;
        data.mactFeedback.salesLeadAmount = from1.salesLeadAmount;
        data.mactFeedback.unCollectionReason = '';
      }
      data.mactFeedback.questionnaireAmount = from1.questionnaireAmount;
      data.mactFeedback.unCollectionReason = from1.unCollectionReason;
      data.mactFeedback.salesLeadAmount = from1.salesLeadAmount;
      data.mactFeedback.userType = this.roleObj.role === 'saler' ? '1' : '2'; // 反馈人员类别(1-销售 2-品推)
      // 活动版块
      const mapCheck = new Map();
      for (const key in this.multiSelectList) {
        mapCheck.set(key, this.multiSelectList[key]);
      }
      data.fbActivityDuty = []; // 活动职责
      // from2.fbActivityDuty.forEach(item => { // 选中的key
      //   mapCheck.get('fbActivityDuty').forEach(map => { // 所有选项
      //     if (item === map.fieldKey) {
      //       data.fbActivityDuty.push(
      //         {
      //           field_key: item,
      //           field_name: map.fieldValue
      //         }
      //       );
      //     }
      //   });
      // });
      data.fbMeeting = []; // 活动板块-会议
      data.fbProductExperience = []; // 活动板块-产品体验
      data.fbTemplate = []; // 活动板块-样板参观
      data.fbLiveBroadcast = []; // 活动板块-线上直播
      data.fbExhibition = []; // 活动板块-展会
      data.fbCase = []; // 活动板块-策划案
      data.fbSupport = []; // 活动板块-特殊支持
      data.fbCustomerPlatform = []; // 活动板块-客户站台
      data.fbExperience = []; // 活动板块-体验中心参观
      // console.log('from2.activitiesSection', from2.activitiesSection);
      // from2.activitiesSection.forEach(item => {
      //   item.value.forEach(itemValue => {
      //     mapCheck.get('fbMeeting').forEach(mapItem => {
      //       if (itemValue === mapItem.fieldKey) {
      //         data.fbMeeting.push(
      //           {
      //             field_key: mapItem.fieldKey,
      //             field_name: mapItem.fieldValue
      //           }
      //         );
      //       }
      //     });
      //     mapCheck.get('fbProductExperience').forEach(mapItem => {
      //       if (itemValue === mapItem.fieldKey) {
      //         data.fbProductExperience.push(
      //           {
      //             field_key: mapItem.fieldKey,
      //             field_name: mapItem.fieldValue
      //           }
      //         );
      //       }
      //     });
      //     mapCheck.get('fbTemplate').forEach(mapItem => {
      //       if (itemValue === mapItem.fieldKey) {
      //         data.fbTemplate.push(
      //           {
      //             field_key: mapItem.fieldKey,
      //             field_name: mapItem.fieldValue
      //           }
      //         );
      //       }
      //     });
      //     mapCheck.get('fbLiveBroadcast').forEach(mapItem => {
      //       if (itemValue === mapItem.fieldKey) {
      //         data.fbLiveBroadcast.push(
      //           {
      //             field_key: mapItem.fieldKey,
      //             field_name: mapItem.fieldValue
      //           }
      //         );
      //       }
      //     });
      //     mapCheck.get('fbExhibition').forEach(mapItem => {
      //       if (itemValue === mapItem.fieldKey) {
      //         data.fbExhibition.push(
      //           {
      //             field_key: mapItem.fieldKey,
      //             field_name: mapItem.fieldValue
      //           }
      //         );
      //       }
      //     });
      //     mapCheck.get('fbCase').forEach(mapItem => {
      //       if (itemValue === mapItem.fieldKey) {
      //         data.fbCase.push(
      //           {
      //             field_key: mapItem.fieldKey,
      //             field_name: mapItem.fieldValue
      //           }
      //         );
      //       }
      //     });
      //     mapCheck.get('fbSupport').forEach(mapItem => {
      //       if (itemValue === mapItem.fieldKey) {
      //         data.fbSupport.push(
      //           {
      //             field_key: mapItem.fieldKey,
      //             field_name: mapItem.fieldValue
      //           }
      //         );
      //       }
      //     });
      //     mapCheck.get('fbCustomerPlatform').forEach(mapItem => {
      //       if (itemValue === mapItem.fieldKey) {
      //         data.fbCustomerPlatform.push(
      //           {
      //             field_key: mapItem.fieldKey,
      //             field_name: mapItem.fieldValue
      //           }
      //         );
      //       }
      //     });
      //     mapCheck.get('fbExperience').forEach(mapItem => {
      //       if (itemValue === mapItem.fieldKey) {
      //         data.fbExperience.push(
      //           {
      //             field_key: mapItem.fieldKey,
      //             field_name: mapItem.fieldValue
      //           }
      //         );
      //       }
      //     });
      //   });
      // });
      data.fbReportOptimization = []; // 报告内容优化
      // from2.fbReportOptimization.forEach(item => {
      //   mapCheck.get('fbReportOptimization').forEach(map => {
      //     if (item === map.fieldKey) {
      //       if (item === 'OPT_07') {
      //         data.fbReportOptimization.push({
      //           field_key: map.fieldKey,
      //           field_name: map.fieldValue,
      //           other: this.formData2.other
      //         });
      //       } else {
      //         data.fbReportOptimization.push({
      //           field_key: map.fieldKey,
      //           field_name: map.fieldValue
      //         });
      //       }
      //     }
      //     ;
      //   });
      // });
      data.fbCustomerType = []; // 客户类型
      from1.fbCustomerType.forEach(item => {
        mapCheck.get('fbCustomerType').forEach(map => {
          if (item === map.fieldKey) {
            data.fbCustomerType.push({
              field_key: map.fieldKey,
              field_name: map.fieldValue
            });
          }
        });
      });
      data.fbLater = []; // 活动支持情况-后期支持
      from1.fbLater.forEach(item => {
        mapCheck.get('fbLater').forEach(map => {
          if (item === map.fieldKey) {
            data.fbLater.push({
              field_key: map.fieldKey,
              field_name: map.fieldValue
            });
          }
        });
      });
      data.fbEarly = []; // 活动支持情况-前期支持
      from1.fbEarly.forEach(item => {
        mapCheck.get('fbEarly').forEach(map => {
          if (item === map.fieldKey) {
            data.fbEarly.push({
              field_key: map.fieldKey,
              field_name: map.fieldValue
            });
          }
        });
      });
      data.fbSupportSituation = []; // 品推支持情况
      mapCheck.get('fbSupportSituation').forEach(map => {
        if (from1.fbSupportSituation === map.fieldKey) {
          data.fbSupportSituation.push({
            field_key: map.fieldKey,
            field_name: map.fieldValue
          });
        }
      });
      data.fbRemarks = []; // 活动支持情况-备注
      from1.fbRemarks.forEach(item => {
        mapCheck.get('fbRemarks').forEach(map => {
          if (item === map.fieldKey) {
            data.fbRemarks.push({
              field_key: map.fieldKey,
              field_name: map.fieldValue
            });
          }
        });
      });
      if (this.roleObj.complete === '1') {
        // 编辑：需要传id值
        data.mactFeedback.id = this.roleObj.feedbackId;
      }
      ExecutionFeedbackServer.verificationFeedback(data.mactFeedback).then(res => {
        confirmPrecheck(this, res, {
          originalBizId: (data.mactFeedback && data.mactFeedback.activityCode) || ''
        }).then(confirmed => {
          if (confirmed) {
            this.feedbackAxios(data);
          }
        });
      }).catch(() => {
        notifyDetectFailed(this);
      });
    },
    async feedbackAxios (data) {
      try {
        // 提交执行反馈
        const result = await ExecutionFeedbackServer.feedback(data);
        if (result.status === '200') {
          // 按钮文字变为“编辑”
          this.btn_content = this.$t('btn.Edit');
          // 页面文本框设为disable
          this.disable = true;
          this.$notify.success(this.$t('general.OperSucc'));
          // 重新从数据库加载数据
          await this.feedbackListAxios();
          await this.feedbackUseAxios();
          this.loadingMask.close();
          this.$router.push({
            path: '/activityDetails',
            query: {
              activityCode: this.$route.query.activityCode,
              activeName: 'activityBasicInformation',
              refreshFlag: this.$route.query.refreshFlag
                ? Number(this.$route.query.refreshFlag) + 1
                : 1
            }
          });
        }
      } catch (e) {}
    },
    async feedbackOptionsAxios () {
      this.cardLoading = true;
      this.formData2.activitiesSection = [];
      try {
        const result = await ExecutionFeedbackServer.feedbackOptions();
        if (result.status === '200') {
          const dataCopy = JSON.parse(JSON.stringify(result.data));
          const mapList = new Map();
          for (const key in dataCopy) {
            mapList.set(key, dataCopy[key]);
          }
          this.activitiesSectionList.forEach((item, index) => {
            item.list = mapList.get(item.key);
            this.formData2.activitiesSection.push({
              key: item.key,
              value: []
            });
          });
          this.multiSelectList = dataCopy; // 前期支持
          // *      fbEarly                活动支持情况-前期支持
          // *      fbLater                活动支持情况-后期支持
          // *      fbCustomerType        客户类型
          // *      fbActivityDuty        活动职责
          // *      fbMeeting              活动板块-会议
          // *      fbProductExperience   活动板块-产品体验
          // *      fbTemplate             活动板块-样板参观
          // *      fbLiveBroadcast       活动板块-线上直播
          // *      fbExhibition           活动板块-展会
          // *      fbCase                 活动板块-策划案
          // *      fbSupport              活动板块-特殊支持
          // *      fbCustomer_platform    活动板块-客户站台
          // *      fbExperience           活动板块-体验中心参观
          // *      fbReportOptimization  报告内容优化
          // *      fbRemarks              备注
          // *      fbSupportSituation     品推支持情况
        }
      } catch (e) {}
      this.cardLoading = false;
    },
    getChannelNameList (params) {
      this.selectLoading = true;
      let interfaceFun = this.formData1.isInternationalQd
        ? newApplicationFormApi.getInternationalNameList(params)
        : newApplicationFormApi.getChannelNameList(params);
      interfaceFun.then(res => {
        if (res.status === '200') {
          if (res.data && res.data.length > 0) {
            this.qdNameList = res.data.map(item => {
              return {
                ...item,
                CompanyName: `${item.companyName}`
              };
            });
          } else {
            this.qdNameList = [];
          }
        }
        this.selectLoading = false;
      });
    },
    // 渠道下拉
    qdMethods (name) {
      if (!this.formData1.unionCustomerType) {
        this.$message.error(this.$t('newApp.activityInfo.pscst'));
        return;
      }
      this.selectLoading = true;
      if (name !== '') {
        if (timer) {
          window.clearTimeout(timer);
        }
        timer = setTimeout(() => {
          // this.feedbackQdName(name);
          let params = {
            partnerType: this.formData1.unionCustomerType,
            companyName: name
          };
          this.getChannelNameList(params);
        }, 200);
      }
    },
    async feedbackQdName (name) {
      try {
        let params = {
          partnerType: '',
          companyName: name
        };
        const result = await ExecutionFeedbackServer.feedbackQdName(params);
        if (result.status === '200') {
          this.qdNameList = result.data;
        }
      } catch (e) {}
    },
    handleDetails (row) {
      this.$refs.ExecutionFeedbackModel.handleOpen(row); //, this.roleObj.role
    },
    async feedbackListAxios () {
      this.tableLoading = true;
      try {
        const result = await ExecutionFeedbackServer.feedbackList(
          this.activityCode
        );
        if (result.status === '200') {
          this.tableData = result.data.filter(item => item.show === 1);
        }
      } catch (e) {}
      this.tableLoading = false;
    },
    async feedbackUseAxios () {
      try {
        const result = await ExecutionFeedbackServer.feedbackUse(
          this.activityCode
        );
        if (result.status === '200') {
          // imc表示此人为“品推”，需要填写的字段多于“销售”（saler）
          // complete 0-未曾填写，1-本人已填写过，点击查看后可以直接编辑表单
          this.roleObj = result.data;
          await this.feedbackListAxios();
          if (this.roleObj.complete === '1') {
            // 查看页面，按钮为编辑
            await this.feedbackOneAxios(this.roleObj.feedbackId);
            this.disable = true;
            this.btn_content = this.$t('btn.Edit');
          } else {
            // 新增页面，按钮为提交
            await this.feedbackOneAxios(null); // queryMyFeedback，虽然本人没有反馈信息，但可以复用这个接口查询到别人提交的公共字段，用于填充页面
            this.disable = false;
            this.btn_content = this.$t('btn.Submit');
          }
        }
      } catch (e) {}
    },
    async feedbackOneAxios (feedbackId) {
      this.tableLoading = true;
      try {
        let result;
        result = await ExecutionFeedbackServer.queryMyFeedback(
          this.activityCode
        );
        // 若返回值为null
        if (result.status === '200' && result.data == null) {
          this.formData1.customerAmountDm = '--';
          this.oldVersion = '0';
          this.feedBackData = {};
        }
        // 若返回值不为null
        if (result.status === '200' && result.data != null) {
          const { data } = result;
          this.$set(this.formData1, 'attachFileList', data.attachFileList);
          this.oldVersion =
            isNotEmpty(data.fbEarly) || isNotEmpty(data.fbLater) ? '1' : '0';
          const dataCopy = JSON.parse(JSON.stringify(result.data));
          this.feedBackData = dataCopy;
          // console.log('dataCopy', dataCopy);
          // dmDisable 是否有DM数据
          // this.dmDisable = dataCopy.mactFeedback.updateByDm === 1;
          // 开始/结束时间
          // if (dataCopy.mactFeedback.realStartDate != null) {
          //   this.formData1.realStartDate = dataCopy.mactFeedback.realStartDate.split(
          //     ' '
          //   )[0];
          // }
          // if (dataCopy.mactFeedback.realEndDate != null) {
          //   this.formData1.realEndDate = dataCopy.mactFeedback.realEndDate.split(
          //     ' '
          //   )[0];
          // }
          if (dataCopy.mactFeedback.realStartDate != null) {
            this.formData1.realStartDate = dataCopy.mactFeedback.realStartDate.replace(/\//g, '-');
          }
          if (dataCopy.mactFeedback.realEndDate != null) {
            this.formData1.realEndDate = dataCopy.mactFeedback.realEndDate.replace(/\//g, '-');
          }
          // 前期支持
          this.formData1.fbEarly = [];
          this.formData1.fbEarlyStr = '';
          if (isNotEmpty(dataCopy.fbEarly)) {
            dataCopy.fbEarly.forEach(item => {
              this.formData1.fbEarly.push(item.fieldKey);
              this.formData1.fbEarlyStr += item.fieldName + '、';
            });
            this.formData1.fbEarlyStr = this.formData1.fbEarlyStr.substring(
              0,
              this.formData1.fbEarlyStr.length - 1
            );
          }
          // 后期支持
          this.formData1.fbLater = [];
          this.formData1.fbLaterStr = '';
          this.formData1.videoUrl = dataCopy.mactFeedback.videoUrl; // 活动视频链接
          this.formData1.kolShare = ['0', '1', 0, 1].includes(dataCopy.mactFeedback.kolShare)
            ? dataCopy.mactFeedback.kolShare + ''
            : '';
          this.formData1.machineDemo = ['0', '1', 0, 1].includes(dataCopy.mactFeedback.machineDemo)
            ? dataCopy.mactFeedback.machineDemo + ''
            : '';
          if (isNotEmpty(dataCopy.fbLater)) {
            dataCopy.fbLater.forEach(item => {
              this.formData1.fbLater.push(item.fieldKey);
              this.formData1.fbLaterStr += item.fieldName + '、';
            });
            this.formData1.fbLaterStr = this.formData1.fbLaterStr.substring(
              0,
              this.formData1.fbLaterStr.length - 1
            );
          }
          // 备注
          this.formData1.fbRemarks = [];
          this.formData1.fbRemarksStr = '';
          if (isNotEmpty(dataCopy.fbRemarks)) {
            this.isRepetition =
              dataCopy.fbRemarks.findIndex(
                item => item.fieldKey === 'REMARKS_01'
              ) !== -1;
            this.isOther =
              dataCopy.fbRemarks.findIndex(
                item => item.fieldKey === 'REMARKS_04'
              ) !== -1;
            dataCopy.fbRemarks.forEach((item, i) => {
              this.formData1.fbRemarks.push(item.fieldKey);
              if (i !== dataCopy.fbRemarks.length - 1) {
                this.formData1.fbRemarksStr += item.fieldValue + '、';
              } else {
                this.formData1.fbRemarksStr += item.fieldValue;
              }
            });
          } else {
            this.formData1.fbRemarksStr = '-';
          }
          // 客户类型
          this.formData1.fbCustomerType = [];
          this.formData1.fbCustomerTypeStr = '';
          if (isNotEmpty(dataCopy.fbCustomerType)) {
            dataCopy.fbCustomerType.forEach(item => {
              // if (item.fieldKey === 'CT_02' && this.formData1.fbRemarks.findIndex(item => item === 'REMARKS_03') === -1) {
              //   this.formData1.fbRemarks.push('REMARKS_03');
              // }
              this.formData1.fbCustomerType.push(item.fieldKey);
              this.formData1.fbCustomerTypeStr += item.fieldName + '、';
            });
            this.formData1.fbCustomerTypeStr =
              this.formData1.fbCustomerTypeStr.substring(
                0,
                this.formData1.fbCustomerTypeStr.length - 1
              ) || '-';
          }
          // 实际参会人数
          // this.formData1.customerAmount = dataCopy.mactFeedback.customerAmount;
          // 实际参会人数-DM
          if (
            dataCopy.mactFeedback.customerAmountDm == null ||
            dataCopy.mactFeedback.customerAmountDm == ''
          ) {
            this.formData1.customerAmountDm = '--';
          } else {
            this.formData1.customerAmountDm =
              dataCopy.mactFeedback.customerAmountDm;
          }
          // 是否联合活动
          if (
            dataCopy.mactFeedback.isUnionMarket != null &&
            dataCopy.mactFeedback.isUnionMarket !== undefined
          ) {
            this.$set(
              this.formData1,
              'isUnionMarket',
              dataCopy.mactFeedback.isUnionMarket.toString()
            );
            if (dataCopy.mactFeedback.isUnionMarket.toString() === '1') {
              this.formData1.isUnionMarketStr = this.$t('general.yes');
            } else {
              this.formData1.isUnionMarketStr = this.$t('general.no');
            }
          } else {
            this.formData1.isUnionMarketStr = this.$t('general.no');
          }
          // 是否国际渠道
          this.formData1.isInternationalQd =
            dataCopy.mactFeedback.isInternationalQd;
          // 渠道签约类型
          this.formData1.unionCustomerType =
            dataCopy.mactFeedback.unionCustomerType;
          // 联合的服务商/渠道
          this.formData1.unionCustomer = dataCopy.mactFeedback.unionCustomer;
          const isFillQuestionnaire = dataCopy.mactFeedback.isFillQuestionnaire;
          this.$set(
            this.formData1,
            'isFillQuestionnaire',
            isFillQuestionnaire !== null ? isFillQuestionnaire.toString() : ''
          );
          this.$set(
            this.formData1,
            'isFillQuestionnaireStr',
            this.formData1.isFillQuestionnaire === '1'
              ? this.$t('general.yes')
              : this.$t('general.no')
          );
          this.$set(
            this.formData1,
            'unCollectionReason',
            dataCopy.mactFeedback.unCollectionReason
          );
          this.$set(
            this.formData1,
            'questionnaireAmount',
            dataCopy.mactFeedback.questionnaireAmount
          );
          this.$set(
            this.formData1,
            'salesLeadAmount',
            dataCopy.mactFeedback.salesLeadAmount
          );
          this.$set(
            this.formData1,
            'relationCode',
            dataCopy.mactFeedback.relationCode
          );
          this.$set(this.formData1, 'other', dataCopy.mactFeedback.other);
          this.$set(
            this.formData1,
            'isImportantActivity',
            dataCopy.mactFeedback.isImportantActivity.toString()
          );
          this.$set(
            this.formData1,
            'isImportantActivityStr',
            dataCopy.mactFeedback.isImportantActivity
              ? this.$t('general.yes')
              : this.$t('general.no')
          );
          this.$set(
            this.formData1,
            'fbSupportSituation',
            dataCopy.fbSupportSituation[0].fieldKey
          );
          this.$set(
            this.formData1,
            'fbSupportSituationStr',
            dataCopy.fbSupportSituation[0].fieldValue || '-'
          );

          // 活动职责
          this.formData2.fbActivityDuty = [];
          this.formData2.fbActivityDutyStr = '';
          if (dataCopy.fbActivityDuty) {
            dataCopy.fbActivityDuty.forEach(item => {
              this.formData2.fbActivityDuty.push(item.fieldKey);
              this.formData2.fbActivityDutyStr += item.fieldValue + '、';
            });
            this.formData2.fbActivityDutyStr = this.formData2.fbActivityDutyStr.substring(
              0,
              this.formData2.fbActivityDutyStr.length - 1
            );
          }
          // 报告内容优化
          this.formData2.fbReportOptimization = [];
          this.formData2.fbReportOptimizationStr = '';
          this.formData2.other = '';
          if (dataCopy.fbReportOptimization) {
            dataCopy.fbReportOptimization.forEach(item => {
              this.formData2.fbReportOptimization.push(item.fieldKey);
              if (item.fieldKey === 'OPT_07') {
                this.formData2.other = item.note;
                this.formData2.fbReportOptimizationStr +=
                  item.fieldValue + ':' + item.note + '、';
              } else {
                this.formData2.fbReportOptimizationStr +=
                  item.fieldValue + '、';
              }
            });
            this.formData2.fbReportOptimizationStr = this.formData2.fbReportOptimizationStr.substring(
              0,
              this.formData2.fbReportOptimizationStr.length - 1
            );
          }
          //
          this.formData2.isFillQuestionnaire = dataCopy.mactFeedback.isFillQuestionnaire.toString();
          this.formData2.isFillQuestionnaireStr =
            this.formData2.isFillQuestionnaire === '1'
              ? this.$t('general.yes')
              : this.$t('general.no');
          this.formData2.unCollectionReason =
            dataCopy.mactFeedback.unCollectionReason;
          this.formData2.questionnaireAmount =
            dataCopy.mactFeedback.questionnaireAmount;
          this.formData2.salesLeadAmount =
            dataCopy.mactFeedback.salesLeadAmount;
          const map = new Map();
          for (const key in dataCopy) {
            map.set(key, dataCopy[key]);
          }
          // console.log('map', map);
          this.formData2.activitiesSectionStrList = [];
          // console.log('this.formData2.activitiesSection', this.formData2.activitiesSection);
          this.formData2.activitiesSection.forEach(item => {
            item.value = [];
            // console.log('item', item);
            let arr = [];
            map.get(item.key).forEach(map => {
              item.value.push(map.fieldKey);
              // console.log('item.value', item.value);
              arr.push(map.fieldValue);
            });
            this.formData2.activitiesSectionStrList.push(arr.join('、'));
          });
          // 支持人员
          this.formData2.supporter = [];
          this.formData2.supporterStr = '';
          const supporterList = dataCopy.mactFeedback.supporter.split(';');
          supporterList.forEach(item => {
            if (item !== '') {
              this.getSalesmanListAxios(item.split('|')[0]);
              this.formData2.supporter.push({
                userId: item.split('|')[0],
                userName: item.split('|')[1]
              });
              this.formData2.supporterStr += item.split('|')[1] + '、';
            }
          });
          this.formData2.supporterStr = this.formData2.supporterStr.substring(
            0,
            this.formData2.supporterStr.length - 1
          );
        }
        // 刷新联合的服务商/渠道状态
        // this.changeUnionMarket(this.formData1.isUnionMarket);
      } catch (e) {}
      this.tableLoading = false;
    },
    customerAmountFilter (val) {
      let numVal = val.replace(/[^\d]/g, '').replace(/^0[0-9]+/g, '0');
      this.$set(this.formData1, 'customerAmount', numVal);
    },
    questionnaireAmountFilter (val) {
      let numVal = val.replace(/[^\d]/g, '').replace(/^0[0-9]+/g, '0');
      this.$set(this.formData2, 'questionnaireAmount', numVal);
    },
    salesLeadAmountFilter (val) {
      let numVal = val.replace(/[^\d]/g, '').replace(/^0[0-9]+/g, '0');
      this.$set(this.formData2, 'salesLeadAmount', numVal);
    }
  }
};
</script>

<style lang="scss">
#ExecutionFeedback {
  .customer {
    > label {
      line-height: 20px;
    }
  }
  .el-input {
    width: 100%;
  }
  .el-table {
    th {
      background-color: #ebeef5;
      border-right: 1px solid #dcdfe6;
    }
    thead {
      color: #606266;
    }
  }
  .remark-box {
    display: flex;
    .el-input {
      width: 250px;
      margin-left: 30px;
    }
    .remark-value {
      margin-left: 30px;
      line-height: 40px;
    }
  }
}
</style>
